import { Component, Inject, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';
import { AccountType } from '../../core/constants/accountTypes';
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';

interface TreeNode {
  id: number;
  name: string;
  parentAccountId: string;
  code: string;
  accountType: string;
  parentAccount: string;
  isEditable: boolean;
  children?: TreeNode[];
  level?: number; // Add the level property as optional
}
@Component({
  selector: 'app-chart-accounts',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    // PermissionDirective
  ],
  templateUrl: './chart-accounts.component.html',
  styleUrl: './chart-accounts.component.scss',
})
export class ChartAccountsComponent {
  accountType: AccountType|null = null;
  search: any;
  parentAccountId: any;
  isSubAccount: any;
  rowData: any;
  data: TreeNode[] = [];
  // filterForm: FormGroup;
  filter: any;
  isDropdownOpen = false;
  readonly dialog = inject(MatDialog);
  public accountTypes = Object.values(AccountType);
  searchInputControl: FormControl = new FormControl();
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  type: any = '';
  canListChartAccount$ = this.permissionService.hasPermission(
        ModuleIds.ChartAccount,
        'List'
      );
      canCreateChartAccount$ = this.permissionService.hasPermission(
        ModuleIds.ChartAccount,
        'Create'
      );
    canEditChartAccount$ = this.permissionService.hasPermission(
        ModuleIds.ChartAccount,
        'Edit'
      );
      canDeleteChartAccount$ = this.permissionService.hasPermission(
        ModuleIds.ChartAccount,
        'Delete'
      );
  // profileName: any;
  // Permission = Permission;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private chartAccountService: ChartOfAccountsService,
    private permissionService: PermissionService
  ) {
    // this.filterForm = this.fb.group({
    //   accountType: this.fb.array([]),
    // });

    // const loggedInUser: any = localStorage.getItem('loggedInUser');
    // const userData = JSON.parse(loggedInUser);
    // this.profileName = userData?.profileData?.profileName;
  }

  ngOnInit() {
    this.fetchChartAccounts();
    this.searchInputControl.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data) => {
        this.search = data;
        this.fetchChartAccounts();
      });
  }

  // get accountTypesFormArray() {
  //   return this.filterForm.get('accountType') as FormArray;
  // }

  // private addControls(formArrayName: string, data: any[] = []) {
  //   const formArray = this.filterForm.get(formArrayName) as FormArray;
  //   formArray.clear();

  //   data.forEach(() => {
  //     formArray.push(new FormControl(false));
  //   });
  // }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  getTableRows(node: TreeNode, level: number = 0): TreeNode[] {
    let rows: TreeNode[] = [{ ...node, level }];

    if (node.children && node.children.length > 0) {
      for (let child of node.children) {
        rows = [...rows, ...this.getTableRows(child, level + 1)];
      }
    }

    return rows;
  }

  getNodeClass(node: TreeNode): string | string[] {
    // Apply 'child' class for the first child, and 'child2' for the second, based on your requirements
    if (node.level === 0) {
      return 'title';
    } else if (node.level === 1) {
      return 'sub-title';
    } else if (node.level === 2) {
      return 'sub-title';
    } else if (node.level === 3) {
      return 'sub-total';
    }

    // You can add more conditions if necessary
    return '';
  }

  fetchChartAccounts() {
    this.chartAccountService.fetchChartAccounts(this.search,this.accountType).subscribe({
      next: (data) => {
        const accountMap = new Map<number, TreeNode>();
        data.forEach((account: any) => {
          const node: TreeNode = {
            id: account.id,
            name: account.accountName,
            parentAccountId: account.parentAccountId,
            code: account.accountCode || '',
            isEditable: account?.isControl || false,
            accountType: account.accountType || '',
            parentAccount: account.parentAccountData?.accountName || '--',
            level: 0,
            children: [],
          };
          accountMap.set(account.id, node);
        });

        accountMap.forEach((node, id) => {
          const account = data.find((a: any) => a.id === id);

          if (account && account.parentAccountId) {
            const parentNode: any = accountMap.get(account.parentAccountId);

            if (parentNode) {
              parentNode.children.push(node);
              node.level = parentNode.level + 1;
            }
          }
        });
        this.data = Array.from(accountMap.values()).filter(
          (data: any) =>
            data.parentAccountId === null ||
            !accountMap.has(data.parentAccountId)
        );
        // this.data = Array.from(accountMap.values()).filter((data: any) => data && data?.parentAccountId === null);
      },
      error: (err) => {
        console.error('Error fetching chart accounts:', err);
      },
    });
  }

  onConfirmDelete(id: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.onDelete(id);
      }
    });
  }

  onDelete(id: any) {
    this.chartAccountService.removeChartOfAccount(id).subscribe({
      next: (result) => {
        if (result === true) {
          this.toastr.success('Account deleted successfully', 'Success');
          this.fetchChartAccounts();
        }
      },
      error: (error) => {
        this.toastr.error(error, 'Error');
      },
    });
  }

  onEdit(id: any) {
    const dialogRef = this.dialog.open(ChartAccountDialog, {
      disableClose: true,
      data: id,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.getLeaveApprovals(this.leaveId,"LEAVE");
        this.fetchChartAccounts();
        this.toastr.success('Account updated successfully', 'Success');
      }
    });
  }

  onSubmit(event: Event) {
    event.preventDefault();
    this.fetchChartAccounts();   
    this.toggleDropdown();                    
  }

  onStatusChange(type: AccountType) {
      this.accountType = this.accountType === type ? null : type;
    }

  clearFilter() {
    this.accountType = null; // reset to no filter
    this.fetchChartAccounts();
  }
}

@Component({
  selector: 'chart-account-dialog',
  templateUrl: 'chart-account-dialog.component.html',
  styleUrls: ['./chart-accounts.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule
],
})
export class ChartAccountDialog {
  // @ViewChild('LeaveApprovalsComponent')LeaveApprovalsComponent: LeaveApprovalsComponent;
  status: boolean;
  approvedStatus: string = '';
  leaveId: number;
  accountEditForm: FormGroup;
  rejectedStatus: string;
  accountId: any;
  accountData: any;
  updateData: any;
  parentAccountId: any;
  isSubAccount: boolean;
  isControl: boolean;
  search: any;
  accountType: any;
  accounts = Object.values(AccountType);
  subAccount: any;
  chartAccounts: any;
  filteredChartAccounts: any;
  private searchSubject = new Subject<string>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private chartAccountsService: ChartOfAccountsService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ChartAccountDialog>
  ) {}

  ngOnInit() {
    this.initForm();
    this.accountId = this.data;
    this.fetchAccountById();
    this.fetchChartAccounts();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.search = searchTerm;
        this.fetchChartAccounts();
      });    
  }

  initForm() {
    this.accountEditForm = this.fb.group({
      id: [''],
      accountType: ['', Validators.required],
      accountName: ['', Validators.required],
      parentAccountId: [''],
      accountCode: ['', Validators.required],
      isControl: [false],
      status: 1,
    });
  }

  fetchAccountById() {
    this.chartAccountsService.chartOfAccountsById(this.accountId).subscribe({
      next: (data) => {
        this.accountData = data;
        console.log(this.accountData);
        this.patchData();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  patchData() {
    this.accountEditForm.patchValue({
      id: this.accountData.id,
      accountType: this.accountData.accountType,
      accountName: this.accountData.accountName,
      parentAccountId: this.accountData.parentAccountId,
      accountCode: this.accountData.accountCode,
      isControl: this.accountData.isControl,
      isSubAccount: this.accountData.isSubAccount,
      status: this.accountData.status,
    });
    this.isSubAccount = !!this.accountData.parentAccountId;
  }

  toggleSubAccount(checked: boolean) {
    this.isSubAccount = checked;
    this.accountEditForm.patchValue({
      isSubAccount: checked,
    });
  }

  onVendorSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  onEdit() {
    if (this.accountEditForm.value.parentAccountId) {
      this.parentAccountId = Number(this.accountEditForm.value.parentAccountId);
    }
    this.updateData = this.accountEditForm.value;
    this.chartAccountsService.updateChartOfAccount(this.updateData).subscribe({
      next: (data) => {
        this.dialogRef.close(data);
        // this.LeaveApprovalsComponent.leaveApprovals();
      },
      error: (error) => {
        this.toastr.error(error?.message, 'Error');
      },
    });
  }

  fetchChartAccounts() {
    this.chartAccountsService.fetchChartAccounts(this.search).subscribe({
      next: (data) => {
        this.chartAccounts = data;
        const currentName = this.accountEditForm.get('accountName')?.value;

        this.filteredChartAccounts = this.chartAccounts.filter(
          (acc:any) =>
            acc.accountName.trim().toLowerCase() !==
            currentName.trim().toLowerCase()
        );
      },
      error: (err) => {
        console.error('Error fetching chart accounts:', err);
      },
    });
  }
}
